export const NOTIFICATIONS_STALE_TIME = 10 * 60 * 1000;
export const NOTIFICATIONS_PAGINATION_SIZE = 30;
